import React from 'react';
import Parcel from 'single-spa-react/parcel';
import { mountRootParcel } from 'single-spa';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StateParams } from '../../store/reducers';

// System is provided globally by the SystemJS runtime loaded in index.html.
// Accessed via window to avoid CRA's no-restricted-properties lint rule on System.import.
const systemImport = (name: string): Promise<any> =>
    (window as any).System.import(name);

const PatientFormsParcel: React.FC = () => {
    const navigate = useNavigate();
    const { patientId } = useParams<{ patientId: string }>();

    const practiceId    = useSelector((state: StateParams) => state.account.practiceId);
    const loginSource   = useSelector((state: StateParams) => state.account.loginSource);
    const treatmentId   = useSelector((state: StateParams) => state.signup.treatmentId);
    const appointmentId = useSelector((state: StateParams) => state.signup.appointmentId);
    const checkInId     = useSelector((state: StateParams) => state.signup.checkInId);

    if (!patientId || !practiceId || !loginSource) {
        console.error('PatientFormsParcel: missing required context (patientId, practiceId, loginSource)');
        return null;
    }

    return (
        <Parcel
            config={() => systemImport('@Smalljoys/PatientForms')}
            mountParcel={mountRootParcel}
            patientId={patientId}
            practiceId={practiceId}
            loginSource={loginSource}
            {...(treatmentId   && { treatmentId })}
            {...(appointmentId && { appointmentId })}
            {...(checkInId     && { checkInId })}
            onComplete={() => {
                localStorage.removeItem("sj:patient-session-id");
                Object.keys(sessionStorage).filter(k => k.startsWith('pf_')).forEach(k => sessionStorage.removeItem(k));
                navigate('/patientProfile', { replace: true });
            }}
        />
    );
};

export default PatientFormsParcel;
